import React from "react";
import { TableRow, TableCell } from "@mui/material";

const cellBase = {
  fontSize: "12px",
  borderColor: "#e7edf6",
  py: 1,
  px: 1,
  fontWeight: 900,
  color: "#06185f",
  verticalAlign: 'middle'
};

export default function VendedorTableHeader({
  ui,
  showVendedorColumn = false,
}) {
  const { ESTADIOS, COLORS, WIDTHS } = ui;

  return (
    <TableRow>
      {showVendedorColumn && (
        <TableCell
          align="center"
          sx={{
            ...cellBase,
            width: WIDTHS.vendedorCol || WIDTHS.estadioCol,
            maxWidth: WIDTHS.vendedorCol || WIDTHS.estadioCol,
            minWidth: WIDTHS.vendedorCol || WIDTHS.estadioCol,
            backgroundColor: COLORS.vendedorHeader || "#f7f7f9",
            borderRight: "1px solid #e7edf6",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          Vendedor
        </TableCell>
      )}
      {ESTADIOS.map((s) => (
        <TableCell
          key={s.key}
          align="center"
          sx={{
            ...cellBase,
            width: WIDTHS.estadioCol,
            maxWidth: WIDTHS.estadioCol,
            minWidth: WIDTHS.estadioCol,
            backgroundColor: s.color,
            borderRight: "1px solid #e7edf6",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {s.label}
        </TableCell>
      ))}

      <TableCell
        align="center"
        sx={{
          ...cellBase,
          width: 120,
          backgroundColor: COLORS.estadoHeader,
          borderRight: "1px solid #e7edf6",
        }}
      >
        Estado
      </TableCell>

      <TableCell
        align="center"
        sx={{
          ...cellBase,
          width: 120,
          backgroundColor: COLORS.derechaBg,
        }}
      >
        Seguimiento
      </TableCell>
    </TableRow>
  )
}
